import { ReactNode } from "react"
import { Provider } from "react-redux"

import { store } from "./store"

interface StateProviderProps {
	children: ReactNode
}

export const StateProvider = function ({ children }: StateProviderProps) {
	return <Provider store={store}>{children}</Provider>
}
